export default {
    onShareAppMessage () {
        const sub_page = encodeURIComponent(`/packageB/plates/main?id=${this.pid}`)
        const { cover_image_url, name } = this.plate
        const shareOpt = {
            title: `买房先选板块，360度为您解读${name}板块价值`,
            path: `/pages/index/main?sub_page=${sub_page}`,
            imageUrl: cover_image_url || 'https://cdn.vip-wifi.com/fangchan/img/building/plates/share.png'
        }
        return this.getShareInfo(shareOpt)
    }
}